







































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import dataAuthority from "./dataAuthority.vue";
import {
  rolesList,
  rolesMenu,
  rolesCreate,
  rolesModify,
  rolesCreateData,
  rolesDetail,
  rolesDel,
} from "@/api/setTing";
@Component({
  name: "identiySetting",
  components: {
    dataAuthority,
  },
})
export default class extends Vue {
  @Prop() types!: string;
  rolesList = [];
  roleData = {
    staff: { total: 0, name: [], staff_list: [] },
  };
  formData = {
    name: "",
    describe: "",
  };
  defaultActive = ""; //设置左边菜单选中
  defaultProps = {
    children: "children",
    label: "name",
  }; //定义选中盒子的字段
  checkedKeys = []; //选中的盒子
  checkChange = []; //点击选中的数据
  roleDataList = [];
  role_id = 0;
  type = "";
  rules = {
    name: [{ required: true, message: "请输入名字", trigger: "blur" }],
  };
  inputbtn = false;
  showDialog = false;
  authorityList = [];
  optionChooseDatas = [];
  created() {
    const _t = this as any;
    if (_t.types != "") {
      _t.type = _t.types;
      _t.getrolesMenu();
      _t.showDialog = true;
      rolesList().then((res: any) => {
        if (res.error_code == 0) {
          _t.rolesList = res.data;
        }
      });
    } else {
      _t.getList(() => {});
    }
  }
  getList(cb: Function) {
    const _t = this as any;
    rolesList().then((res: any) => {
      if (res.error_code == 0) {
        let id: number = 0;
        let type: string = "";
        _t.rolesList = res.data;
        if (res.data.custom.length == 0) {
          _t.defaultActive = "2-0";
          id = res.data.system[0].role_id;
          type = "system";
        } else {
          _t.defaultActive = "1-0";
          id = res.data.custom[0].role_id;
          type = "custom";
        }
        _t.type = type;
        if (id != 0) {
          _t.clickRole(id, type);
        }
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
      if (cb) {
        cb();
      }
    });
  }
  clilckrolesDel() {
    const _t = this as any;
    _t.$confirm(
      `所有包含“${_t.roleData.role_name}”身份员工都将失去对应的权限，此操作不可撤销。`,
      `删除 - 身份设置`,
      {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        iconClass: "mwow-icon-error",
      }
    )
      .then(() => {
        rolesDel({ role_id: _t.role_id }).then((res: any) => {
          if (res.error_code == 0) {
            _t.defaultActive = "";
            _t.getList(() => {});
            _t.$message({
              type: "success",
              message: "删除成功",
            });
          } else {
            _t.$message({
              type: "error",
              message: res.message,
            });
          }
        });
      })
      .catch(() => {});
  }
  getrolesMenu() {
    const _t = this as any;
    rolesMenu().then((res: any) => {
      if (res.error_code == 0) {
        // res.data.list.map((a:any,b:number)=>{
        //   res.data.list[b]=[];
        //   res.data.list[b].push(a);
        // })
        // _t.checkedKeys = [];
        _t.roleDataList = [];
        _t.roleData.role_name = "自定义身份";
        _t.roleData.staff.total = 0;
        _t.roleDataList = res.data.list;
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  handleCheckChange(data: any, checked: any) {
    const _t = this as any;
  }
  clickKeep() {
    const _t = this as any;
    _t.$refs["form"].validate((valid: any) => {
      if (valid) {
        const arry: any = [];
        const checkArr = _t.$refs.menuTree.getCheckedNodes(false, true);
        checkArr.map((a: any) => {
          arry.push(a.menu_id);
        });
        if (arry.length == 0) {
          _t.$message({
            type: "error",
            message: "功能权限未勾选",
          });
          return;
        }
        if (_t.type == "add") {
          _t.postRolesCreate({
            menu_rules: arry,
            data_authority: _t.optionChooseDatas,
          });
        } else if (_t.type == "custom") {
          _t.postrolesModify({
            menu_rules: arry,
            role_id: _t.role_id,
            data_authority: _t.optionChooseDatas,
          });
        }
      } else {
        return false;
      }
    });
  }
  postrolesModify(data: rolesCreateData) {
    const _t = this as any;
    if (_t.formData.name != "") {
      data.role_name = _t.formData.name;
    }
    if (_t.formData.describe != "") {
      data.describe = _t.formData.describe;
    }
    rolesModify(data).then((res: any) => {
      if (res.error_code == 0) {
        _t.getList(() => {});
        _t.$message({
          type: "success",
          message: "编辑成功!",
        });
        const content: any = document.querySelector(".layout-content");
        content.scrollTop = 0;
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  postRolesCreate(data: rolesCreateData) {
    const _t = this as any;
    if (_t.formData.name != "") {
      data.role_name = _t.formData.name;
    }
    if (_t.formData.describe != "") {
      data.describe = _t.formData.describe;
    }
    rolesCreate(data).then((res: any) => {
      if (res.error_code == 0) {
        _t.getList(() => {});
        _t.$message({
          type: "success",
          message: "添加成功!",
        });
        const content: any = document.querySelector(".layout-content");
        content.scrollTop = 0;
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  clickRole(e: number, type: string) {
    const _t = this as any;
    _t.role_id = e;
    _t.type = type;
    _t.showDialog = false;
    if (type == "system") {
      _t.inputbtn = true;
    } else {
      _t.inputbtn = false;
    }
    rolesDetail({ role_id: e }).then((res: any) => {
      if (res.error_code == 0) {
        _t.showDialog = true;
        _t.checkedKeys.length = 0;
        _t.itemGetid(res.data.menu, type);
        // res.data.menu.map((a:any,b:number)=>{
        //   res.data.menu[b]=[];
        //   res.data.menu[b].push(a);
        // })
        _t.roleData = res.data;
        _t.roleDataList = res.data.menu;
        const obj = _t.formData;
        obj.name = res.data.role_name;
        _t.formData = obj;
        obj.describe = res.data.describe;
        _t.authorityList = res.data.data_authority;
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  itemGetid = (itemData: any, type: string) => {
    const _t = this as any;
    itemData.map((item: any) => {
      if (item.is_select) {
        if (item.children == null) {
          _t.checkedKeys.push(item.menu_id);
        } else {
          _t.itemGetid(item.children, type);
        }
      }
      if (type == "system") {
        item.disabled = true;
        if (item.children != null) {
          _t.itemGetid(item.children, type);
        }
      }
    });
  };
  optionChooseData(e: any) {
    this.optionChooseDatas = e;
  }
  addRole() {
    const _t = this as any;
    _t.type = "add";
    _t.formData.name = "";
    _t.formData.describe = "";
    _t.defaultActive = "";
    _t.checkedKeys.length = 0;
    _t.inputbtn = false;
    _t.getrolesMenu();
  }
}
